import { setProduct, getAvailableProducts } from "./helpers/products/products";
import MyUser from "src/models/my-user";
import MyAccount from "src/models/my-account";
import Permissions from "src/models/permissions";
import VisibilitySets from "src/models/visibility-sets";
import AccountProperties from "src/models/account-property";
import UserPermission from "src/components/shared/user-permissions";
import initCompanies from "src/components/license-management/overview/init-companies";
import UserPreferences from "src/models/user-preference";
import UserRoles from "src/models/user-roles";
import Refresh from "src/components/shared/refresh";
import { accountPropertyNameFinder } from "src/helpers/account-properties/";
import "src/components/loading-indicator/";
import "./vt-admin";
import "src/components/header/header.component";
import "src/components/sidebar/sidebar.component";
import "src/components/theme-changer/theme-changer.component";

import _some from "lodash/some";
import _find from "lodash/find";
import _filter from "lodash/filter";
import _forEach from "lodash/forEach";
import _toLower from "lodash/toLower";
import Cookies from "js-cookie";

const P_KEY = 'ddf6132a-8359-4446-69e5-965ec739410a';
const getUserPreferences = function loadUserPreferences(loadPreference) {
    "use strict";
    UserPreferences.findAll({ id: Vistracks.myUser.id }).then(
        (responseData) => {
            Vistracks.userPreferences = responseData.serialize();

            const refreshRateInterval = Vistracks.userPreferences.find((userPrefs) => {
                return userPrefs.userId === Vistracks.myUser.id &&
                    userPrefs.key === "com.vistracks.vtlib.REFRESH_RATE_INTERVAL";
            });

            const preparedLanguage = Vistracks.userPreferences.find((userPrefs) => {
                return userPrefs.userId === Vistracks.myUser.id &&
                    userPrefs.key === "com.vistracks.vtlib.PREFERRED_LANGUAGE";
            });

            let refreshRate = refreshRateInterval
                ? parseInt(refreshRateInterval.stringVal, 10)
                : 0;

            if (Cookies.get("refreshRateInterval")) {
                refreshRate = parseInt(Cookies.get("refreshRateInterval"), 10);
            }

            if (Vistracks.myUser.accountId === Vistracks.myAccount.id) {
                Cookies.set("refreshRateInterval", refreshRate, {
                    path: "/",
                    secure: true,
                    sameSite: "None"
                });
            }

            Refresh.attr("notification", false);
            Refresh.attr("interval.value", !refreshRate ? 0 : refreshRate * 1000);
            Vistracks.Scope.AppState.attr("refreshRateInterval", refreshRate);

            const preferenceParams = [
                {
                    userId: Vistracks.myUser.id,
                    key: "com.vistracks.vtlib.PREFERRED_LANGUAGE",
                    prefType: "STRING_PREF",
                    displayName: "Preferred Language",
                    isEditable: true
                }
            ];

            let languageId = 0;
            let requestMethod = "POST";

            if (preparedLanguage) {
                Locale.lang = preparedLanguage.stringVal;
                languageId = preparedLanguage.id;
                requestMethod = "PUT";
            }

            if (Cookies.get("loginLanguage")) {
                const param = { userPreferences: preferenceParams };
                const loginCookieLang = Cookies.get("loginLanguage");

                if (requestMethod === "PUT") {
                    preferenceParams[0].id = languageId;
                    param.id = languageId;
                }

                const languageSave = new UserPreferences(param);
                languageSave.save().then(() => {
                    Locale.lang = loginCookieLang;
                    Locale.setCookieLang(loginCookieLang);
                    loadPreference.resolve();
                    Cookies.set("loginLanguage", "", {
                        expires: new Date(0),
                        domain: ".vistracks.com",
                        path: "/",
                    });
                });
            } else {
                loadPreference.resolve();
            }

            Vistracks.Scope.$el
                .$body.removeClass().addClass(Vistracks.Scope.AppState.attr("themeColor"));
        },
        (responseError) => {
            loadPreference.resolve();
            Vistracks.HelperUtils.jqXHR.errorHandler(responseError);
        }
    );
};

const appModels = function applicationModels(appState) {
    "use strict";

    can.when(
        MyUser.findAll({}),
        MyAccount.findAll({}),
        Permissions.findAll({}),
        UserRoles.findAll({}),
        VisibilitySets.findAll({}),
        AccountProperties.findSomeAccountPropertyNamesOf([
            "hos.locations.api.key",
            "COLOR_THEME",
            "hos.hidden.reports",
            "hos.hide.log.show.edits",
            "portal.external.css.url",
            "hos.carrier.information",
            "hos.disable.shorthaul.logging",
            "hos.dataretention.DVIR",
            "hos.dataretention.ELD",
            "switch.app.button.visible"
        ])
    )
        .then((myUserData, myAccount, permissionsData, userRoles, visibilitySets, accountPropertyNames) => {
            const getAccountPropertyNameOf = accountPropertyNameFinder(accountPropertyNames);

            const theme = getAccountPropertyNameOf("COLOR_THEME");
            const hiddenReports = getAccountPropertyNameOf("hos.hidden.reports");
            const externalCSSUrl = getAccountPropertyNameOf("portal.external.css.url");
            const hideLogShowEdits = getAccountPropertyNameOf("hos.hide.log.show.edits");
            const shorthaulLogging = getAccountPropertyNameOf("hos.disable.shorthaul.logging");
            const dvirDataRetention = getAccountPropertyNameOf("hos.dataretention.DVIR");
            const eldDataRetention = getAccountPropertyNameOf("hos.dataretention.ELD");
            const carrierInformation = getAccountPropertyNameOf("hos.carrier.information");
            const googleMapApiKeyData = getAccountPropertyNameOf("hos.locations.api.key");
            const switchAppButtonVisible = getAccountPropertyNameOf("switch.app.button.visible");

            // Make it global so that all the modules can access it anytime
            Vistracks.myUser = myUserData[0];
            Vistracks.myAccount = myAccount[0];
            Vistracks.permissions = permissionsData;
            Vistracks.myAccount.accountProperties = {};
            const fleetSyncEnabled = !!Vistracks.myAccount.fleetSyncEnabled;
            window.localStorage.setItem("fleetSyncEnabled", JSON.stringify(fleetSyncEnabled));
            pendoAPI(P_KEY);
            sessionStorage.setItem("accountID", Vistracks.myAccount.id ? Vistracks.myAccount.id : null);
            // if(Vistracks.Scope.AppState.attr("isIframeInsideFleet") !== "true") {
            //     pendoAPI(P_KEY);
            // }
            // Hooks
            if (carrierInformation) {
                Vistracks.myAccount.accountProperties.hosCarrierInformation = carrierInformation;
            }

            if (dvirDataRetention) {
                Vistracks.myAccount.accountProperties.dvirDataRetention = dvirDataRetention;
            }

            if (eldDataRetention) {
                Vistracks.myAccount.accountProperties.eldDataRetention = eldDataRetention;
            }

            if (shorthaulLogging) {
                Vistracks.myAccount.accountProperties.shorthaulLogging = shorthaulLogging;
            }

            if (switchAppButtonVisible) {
                Vistracks.myAccount.accountProperties.switchAppButtonVisibility = switchAppButtonVisible;
            }

            if (Vistracks.myUser.accountId === Vistracks.myAccount.id) {
                Cookies.set("isTopLevelAccount", Vistracks.myAccount.topLevel, {
                    path: "/",
                    secure: true,
                    sameSite: "None"
                });
                Cookies.set("isPrimaryAccountReseller", Vistracks.myAccount.isReseller, {
                    path: "/",
                    secure: true,
                    sameSite: "None"
                });
            }

            // Get user roles name
            Vistracks.myUser.userRoles = Cookies.get("userRoles")
                ? Cookies.get("userRoles").split(",")
                : [];

            if (Vistracks.myUser.accountId === Vistracks.myAccount.id) {
                const _userRoles = [];

                _forEach(Vistracks.myUser.userRoleIds, roleId => {
                    const _role = _filter(userRoles, role => role.id === roleId)[0];

                    if (_role) {
                        _userRoles.push(_role.name);
                    }

                    Vistracks.myUser.userRoles = _userRoles;
                });

                Cookies.set("userRoles", _userRoles.join(","), {
                    path: "/",
                    secure: true,
                    sameSite: "None"
                });
            }

            // Set theme color
            if (theme) {
                Vistracks.Scope.AppState.attr("themeColor", theme.value);
            }

            // Set Hidden Reports
            if (hiddenReports && can.trim(hiddenReports.value)) {
                Vistracks.Scope.AppState.attr("hiddenReports", hiddenReports.value.split(","));
            } else {
                Vistracks.Scope.AppState.attr("hiddenReports", []);
            }

            // Set Log Edits and Show Edits visibility
            Vistracks.Scope.AppState.attr("hideLogShowEdits", false);
            if (hideLogShowEdits) {
                Vistracks.Scope.AppState.attr("hideLogShowEdits", hideLogShowEdits.value === "true");
            }

            setTimeout(function () {
                can.route.attr("account", Vistracks.myAccount.name);
            }, 800);

            Vistracks.myProduct = getAvailableProducts(Vistracks.myAccount.features);

            Vistracks.myUserProducts = new can.List([]);
            _forEach(Vistracks.myUser.enabledFeatures, (enabledFeature, index) => {
                const name = (enabledFeature === "WORK_ORDER") ? "Work Orders" : enabledFeature;
                Vistracks.myUserProducts.push({
                    key: index,
                    name,
                    enabledFeature
                });
            });

            let userPermissions = new UserPermission(),
                loadPreference = can.Deferred();

            const googleMapApiKey = googleMapApiKeyData
                ? googleMapApiKeyData.value
                : "";

            // GETting user preferences API.
            getUserPreferences(loadPreference);

            const isUserAdminWithTopLevelAccountAndReseller =
                userPermissions.isUserRoleAdmin() &&
                Cookies.get("isTopLevelAccount") === "true" &&
                Cookies.get("isPrimaryAccountReseller") === "true";

            const isUserAdminWithParentAccountReseller =
                userPermissions.isUserRoleAdmin() &&
                Cookies.get("isPrimaryAccountReseller") === "true";

            const isUserVtAdminWithParentAccountReseller =
                userPermissions.isUserRoleVTAdmin() &&
                Cookies.get("isPrimaryAccountReseller") === "true";

            if (
                isUserAdminWithParentAccountReseller ||
                isUserVtAdminWithParentAccountReseller ||
                isUserAdminWithTopLevelAccountAndReseller
            ) {
                Cookies.set("canConfigureVBUSDeviceTab", true, {
                    path: "/",
                    secure: true,
                    sameSite: "None"
                });
            } else if (userPermissions.isUserRoleAdmin()) {
                Cookies.set("canConfigureVBUSDeviceTab", false, {
                    path: "/",
                    secure: true,
                    sameSite: "None"
                });
            }

            // Update the cached application state.
            const allowSubAccountBranding = (("allowSubAccountBranding" in Vistracks.myAccount) &&
                Vistracks.myAccount.allowSubAccountBranding);

            let hasComplianceSupportCenterFeatures = false;
            if ("features" in myAccount[0]) {
                if ("hasComplianceSupportCenterFeatures" in myAccount[0].features) {
                    hasComplianceSupportCenterFeatures =
                        Vistracks.myAccount.attr("features.hasComplianceSupportCenterFeatures") ? true : false;
                }
            }

            Vistracks.Scope.AppState.attr("allowSubAccountBranding", allowSubAccountBranding);
            Vistracks.Scope.AppState.attr("isReseller", Vistracks.myAccount.isReseller);
            Vistracks.Scope.AppState.attr("isMobileWorker", false);
            Vistracks.Scope.AppState.attr("hasProducts", false);
            Vistracks.Scope.AppState.attr("isNotDriver", true);
            Vistracks.Scope.AppState.attr("googleMapApiKey", googleMapApiKey);

            // Enable the `Mobile Worker` menu if its enabled in the features.
            const mobileWorkerFeatureIsEnabled = Vistracks.myAccount
                .features.hasOwnProperty('workOrder') && Vistracks.myAccount.features.workOrder;

            if (Vistracks.myUser.enabledFeatures.length && mobileWorkerFeatureIsEnabled) {
                Vistracks.Scope.AppState.attr("isMobileWorker", true);
            }

            if (Vistracks.myUser.enabledFeatures.length) {
                Vistracks.Scope.AppState.attr("hasProducts", true);

                const productSize = Vistracks.myUserProducts.length;

                if (productSize) {
                    const setProducts = {};

                    _forEach(Vistracks.myUserProducts, (myUserProduct, index) => {
                        const enabledFeature = can.camelize(
                            _toLower(myUserProduct.enabledFeature).replace(/\_/g, "-")
                        );
                        const userProductInFeatures = (enabledFeature in Vistracks.myAccount.attr("features"));

                        if (userProductInFeatures && Vistracks.myAccount.attr(`features.${enabledFeature}`)) {
                            setProducts[myUserProduct.name] = true;
                        }

                        if (enabledFeature === 'eld' && Vistracks.myAccount.attr("features.logbook")) {
                            setProducts['LOGBOOK'] = true;
                        }

                        if ((index + 1) === productSize) {
                            setProduct(setProducts);
                        }
                    });
                }
            }

            // Load user permissions
            Vistracks.Scope.AppState.attr("permissions", userPermissions.get());

            // Set User if is user role admin
            Vistracks.Scope.AppState.attr("isUserRoleAdmin", userPermissions.isUserRoleAdmin());

            Vistracks.Scope.AppState.attr("canReassignDrivingEvents", userPermissions.canReassignDrivingEvents());

            // Set User if is user role asset admin or higher
            Vistracks.Scope.AppState.attr("isUserRoleAssetAdmin", userPermissions.isUserRoleAssetAdmin());

            Vistracks.Scope.AppState.attr("canViewSubAccounts", userPermissions.canViewSubAccounts());

            // Is this account has an IFTA features?
            Vistracks.Scope.AppState.attr("hasIftaFeatures", Vistracks.myAccount.attr("features.ifta") ? true : false);

            // Is this account has a Google Map features?
            Vistracks.Scope.AppState.attr("hasMapFeatures", Vistracks.myAccount.attr("features.map") ? true : false);
            Vistracks.Scope.AppState.attr(
                "hasEldFeatures",
                Vistracks.myAccount.attr("features.eld") || Vistracks.myAccount.attr("features.logbook") ? true : false
            );
            Vistracks.Scope.AppState.attr("hasDvirFeatures", Vistracks.myAccount.attr("features.dvir") ? true : false);
            Vistracks.Scope.AppState.attr("hasWorkOrderFeatures", Vistracks.myAccount.attr("features.workOrder") ? true : false);
            Vistracks.Scope.AppState.attr("hasComplianceSupportCenterFeatures", hasComplianceSupportCenterFeatures);

            // Show/hide sidebar menus
            Vistracks.Scope.AppState.attr("hasHosPermission", userPermissions.hasHosPermission());
            Vistracks.Scope.AppState.attr("hasIftaPermission", userPermissions.hasIftaPermission());
            Vistracks.Scope.AppState.attr("hasDvirPermission", userPermissions.hasDvirPermission());
            Vistracks.Scope.AppState.attr("hasMobileWorkerPermission", userPermissions.hasMobileWorkerPermission());

            // Show/hide fuel receipts menu
            if (Vistracks.myUser.accountId === Vistracks.myAccount.id ||
                Vistracks.Scope.AppState.permissions.PERM_IS_ACCOUNT_ADMIN ||
                Vistracks.Scope.AppState.permissions.PERM_IS_SYS_ADMIN) {
                Vistracks.Scope.AppState.attr("hideFuelReceipts", false);
            }

            if (externalCSSUrl) {
                if (can.trim(externalCSSUrl.value)) {
                    const link = document.createElement("link");
                    link.setAttribute("id", "externalcss");
                    link.setAttribute("type", "text/css");
                    link.setAttribute("rel", "stylesheet");
                    link.setAttribute("href", externalCSSUrl.value);
                    document.getElementsByTagName("head")[0].appendChild(link);
                }
            }

            loadPreference.done(function () {
                Vistracks.Scope.$el
                    .$main.html(can.view("app.stache", appState));

                Vistracks.Scope.$el
                    .$body.tooltip({ selector: "[data-toggle=tooltip]" });

                VtAdmin.Modules.set(Vistracks.Scope.$el.$body, [
                    "browser",
                    "rightSidebar",
                    "navbar",
                    "skinChanger",
                    "taskAndNotificationScroll",
                    "dropdownMenu"
                ]);
            });

            // Bind the application state to the can.route
            can.route.map(appState);
            can.route.ready();

            const page = can.route.attr("page");
            const slug = can.route.attr("slug");
            Vistracks.Scope.AppState.attr("canAccessCurrentRoute", userPermissions.canAccessRoute(page, slug));

            can.route.bind("change", function (el, newVal, oldVal) {
                const page = can.route.attr("page");
                const slug = can.route.attr("slug");
                Vistracks.Scope.AppState.attr("canAccessCurrentRoute", userPermissions.canAccessRoute(page, slug));
                if (Vistracks.Scope.$el.$body.hasClass("modal-open")) {
                    $(".modal.bootstrap-dialog").modal("hide");
                }
            });

            // Cache the route changes
            can.route.bind("slug", function () {
                Cookies.set(
                    "routes",
                    JSON.stringify({
                        page: can.route.attr("page"),
                        slug: can.route.attr("slug"),
                        id: can.route.attr("id"),
                        date: can.route.attr("date"),
                    }),
                    {
                        path: "/",
                        secure: true,
                        sameSite: "None",
                    }
                );
            });

            // Hide refresh button if the page is in HOS Reports
            Vistracks.Scope.AppState.bind("slug", function () {
                this.attr("isHideRefreshBtn", (this.attr("slug") === "hos-reports") ? true : false);
            });

            // Convert JSON stringified into object
            let account = Cookies.getJSON("credentials");
            const suffix = (Vistracks.myUser.suffix) ? Vistracks.myUser.suffix : "";
            const userName = can.trim(`${Vistracks.myUser.firstName} ${Vistracks.myUser.lastName} ${suffix}`);

            if (!account || typeof account !== "object" || !account.user) {
                Cookies.set("credentials", JSON.stringify({ user: userName }), {
                    path: "/",
                    secure: true,
                    sameSite: "None"
                });
                can.route.attr("user", userName);
                account = Cookies.getJSON("credentials");
            }
            else {
                can.route.attr("user", account.user || userName);
            }

            // Manual check to ensure drivers can not see canjs portal, Redirect any driver log-ins to login page
            if (Vistracks.Scope.AppState.attr("isDriverLogin")) {
                window.location.replace("login.html");
            }

            // legacy driver check?
            if (Vistracks.myUser.userRoles.length === 2) {
                const isDriver = _filter(Vistracks.myUser.userRoles,
                    item => item === "USER_ROLE_DRIVER" || item === "PERM_EDIT_DRIVERS"
                );

                if (isDriver.length === 2) {
                    can.route.attr({
                        page: "mobile-worker",
                        slug: "jobsites"
                    });

                    Vistracks.Scope.AppState.attr("isNotDriver", false);
                }
            }
            let host = window.location.hostname;
            const logoSrc = "/api/v2/branding/applicationLogo?image=header&" + new Date().getTime();
            if (host.includes('azuga')) {
                let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.type = 'image/x-icon';
                link.rel = 'shortcut icon';
                link.href = "src/assets/images/favicon.png";
                document.getElementsByTagName('head')[0].appendChild(link);
            } else {
                let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.type = 'image/x-icon';
                link.rel = 'shortcut icon';
                link.href = logoSrc;
                document.getElementsByTagName('head')[0].appendChild(link);
            }

            const userID = Vistracks.myUser.id;
            const loguserIDHistory = localStorage.getItem('UserLogin');

            toastr.options = {
                positionClass: 'toast-top-center',
                tapToDismiss: false,
                closeButton: false,
                preventDuplicates: true,
                showDuration: 300,
                hideDuration: 1000,
                timeOut: 5000,
                extendedTimeOut: 1000,
                onclick: (el) => {
                    if (el.target.className === 'btn clear') {
                        if (!loguserIDHistory) {
                            const newuser = { userID: userID, disabled: true };
                            localStorage.setItem('UserLogin', JSON.stringify(newuser));
                        } else {
                            const listOfUsers = JSON.parse(loguserIDHistory);
                            const addedUser = { userID: userID, disabled: true };
                            const newSetOfUsers = JSON.stringify({ ...listOfUsers }) + '|' + JSON.stringify({ ...addedUser });
                            localStorage.setItem('UserLogin', newSetOfUsers);
                        }

                        toastr.remove();
                    }
                }
            };
        }
        );
};

const pendoAPI = function (apiKey) {
    (function (p, e, n, d, o) {
        var v, w, x, y, z; o = p[d] = p[d] || {}; o._q = o._q || [];
        v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']; for (w = 0, x = v.length; w < x; ++w)(function (m) {
            o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); };
        })(v[w]);
        y = e.createElement(n); y.async = !0; y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
        z = e.getElementsByTagName(n)[0]; z.parentNode.insertBefore(y, z);
    })(window, document, 'script', 'pendo');
    window.pendo.initialize({
        visitor: {
            id: Vistracks.myUser.attr('id'),
            email: Vistracks.myUser.attr('email'),
            firstName: Vistracks.myUser.attr('firstName'),
            lastName: Vistracks.myUser.attr('lastName'),
            lastChangedDate: Vistracks.myUser.attr('lastChangedDate'),
            eulaAcceptedDate: Vistracks.myUser.attr('eulaAcceptedDate')
        },
        account: {
            id: Vistracks.myAccount.attr("id"),
            email: Vistracks.myAccount.attr("email"),
            accountToken: Vistracks.myAccount.attr("accountToken"),
            uuid: Vistracks.myAccount.attr("uuid"),
            name: Vistracks.myAccount.attr("name"),
            rootAccountId: Vistracks.myAccount.attr("rootAccountId"),
            app: 'Azuga ELD Admin Portal'
        }
    });
};

export default appModels;
